module.exports = __webpack_public_path__ + "media/images/home/snack-logo-black_old-757a6e3ce474f4790cd268d7dc639c35.svg";